export class AtlFormChangeEvent extends CustomEvent<{ payload: string }> {
   static EVENT_NAME = 'inputChange';
   constructor(payload: string) {
      super(AtlFormChangeEvent.EVENT_NAME, {
         detail: { payload: payload },
         bubbles: true,
         composed: true,
      });
   }
}

export class AtlFormFileUploadEvent extends CustomEvent<{ payload: FileList }> {
   static EVENT_NAME = 'fileUpload';
   constructor(files: FileList) {
      super(AtlFormFileUploadEvent.EVENT_NAME, {
         detail: { payload: files },
         bubbles: true,
         composed: true,
      });
   }
}
